export default class DateNotValidError extends Error {
    constructor(date: string) {
        super(`Date interval parser, "${date}" is incorect format date.`);
    }
}


// WEBPACK FOOTER //
// ./src/Models/dateModels/exception/DateNotValidError.ts